module.exports = __webpack_public_path__ + "static/media/angular_development.c48452d4.svg";